export default __webpack_public_path__ + "static/media/delivery.b6f74a4d.svg";